import { render, staticRenderFns } from "./NotaryProgressIndicator.vue?vue&type=template&id=45e360c8&scoped=true&"
import script from "./NotaryProgressIndicator.vue?vue&type=script&lang=js&"
export * from "./NotaryProgressIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e360c8",
  null
  
)

export default component.exports